/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import PropTypes from 'prop-types';
import ErrorBanner from '@avtechsoftware/react-component-library/src/components/common/ErrorBanner';
import ProgressSpinner from '@avtechsoftware/react-component-library/src/components/common/ProgressSpinner';
import styles from './SavedThresholdRangeViewModal.module.css';
import ModalComponent from '../../../layout/Modals/ModalComponent/ModalComponent';
import { connectModalContainerContextToComponent } from '../../../../contexts/ModalContext/ModalContext';
import envConfig from '../../../../envConfig';
import RaaAuthenticatedRemoteService from '../../../../utility/RaaAuthenticatedRemoteService';

function SavedThresholdRangeViewModal({
  thresholdRangeId, thresholdRangeName, handleClose, setModalJSX,
}) {
  const [associationData, setAssociationData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [show, setShow] = useState(true);
  const graphAssociations = associationData && associationData.metricsGroupList;
  const alertAssociations = associationData && associationData.alertList;

  const onClose = () => {
    setShow(false);
    handleClose();
    setModalJSX(<></>);
  };

  useEffect(() => {
    if (!thresholdRangeId) return;
    setLoading(true);
    setError(null);
    const controller = new AbortController();
    const fetchData = async () => {
      try {
        const response = await RaaAuthenticatedRemoteService
          .globalInstance()
          .get(`${envConfig.apiUrl}/api/v1/threshold-ranges/resources/${thresholdRangeId}`,
            { signal: controller.signal });
        if (response && response.thresholdRangeAssociatedResources) {
          setAssociationData(response.thresholdRangeAssociatedResources);
        } else setAssociationData(null);
        setLoading(false);
      } catch (err) {
        setError('Error fetching data.');
      }
    };

    fetchData();

    // eslint-disable-next-line consistent-return
    return () => {
      controller.abort();
      onClose();
    };
  }, []);

  return (
    <ModalComponent
      showConfirmCallToAction={false}
      show={show}
      close={onClose}
    >
      <Modal.Header closeButton={false}>
        <Modal.Title className="w-100">
          <div className="clearfix">
            <div className="float-left">{thresholdRangeName}</div>
          </div>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div style={{ padding: '1rem 5rem' }}>
          {
                        error && (
                        <div className="row">
                          <div className="col">
                            <ErrorBanner>
                              {error}
                            </ErrorBanner>
                          </div>
                        </div>
                        )
                    }
          {
                        (loading && !error) && (
                        <div className="row d-flex justify-content-center my-5">
                          <div>
                            <ProgressSpinner />
                          </div>
                        </div>
                        )
                    }
          {
                        (!loading && !error) && (
                        <>
                          <div>
                            <b>
                              Graphed in
                              {' '}
                              {graphAssociations ? graphAssociations.length : '0'}
                              {' '}
                              Data Groups
                            </b>
                          </div>
                          <div className={`mb-3 ${styles.tagContainer}`}>

                            <ul className="list-unstyled">
                              {
                            graphAssociations && graphAssociations.map((graph, index) => (
                              <li className="mb-1" key={`${graph.name}-${index}`}>
                                {graph.name}
                              </li>
                            ))
                        }
                            </ul>
                          </div>
                          <div>
                            <b>
                              Used in
                              {' '}
                              {alertAssociations ? alertAssociations.length : 0}
                              {' '}
                              Alerts
                            </b>
                          </div>
                          <div className={styles.tagContainer}>
                            <ul>
                              {
                            alertAssociations && alertAssociations.map((alert, index) => (
                              <li className="form-group row" key={`${alert.name}-${index}`}>
                                {alert.name}
                              </li>
                            ))
                        }
                            </ul>

                          </div>
                        </>
                        )
          }

        </div>
      </Modal.Body>
    </ModalComponent>
  );
}

SavedThresholdRangeViewModal.propTypes = {
  thresholdRangeId: PropTypes.number.isRequired,
  thresholdRangeName: PropTypes.string.isRequired,
  handleClose: PropTypes.func.isRequired,
  setModalJSX: PropTypes.func.isRequired,
};

export default connectModalContainerContextToComponent(SavedThresholdRangeViewModal);
